import { Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { Box, ThemeProvider } from "@material-ui/core";
import "@bonliva/react-kanban/dist/styles.css";
import { WithAlertDialog, bonlivaPipelineTheme } from "@bonliva-crm/ui";
import { ErrorBoundary } from "@components/error-boundary";
import { ConsultantPipelineBoard } from "./consultant-pipeline-board/consultant-pipeline-board";
import { ConsultantOpportunityStats } from "./consultant-opportunity-stats/consultant-opportunity-stats";
import { ConsultantOpportunityBoard } from "./consultant-opportunity-board/consultant-opportunity-board";
import { ConsultantPipelineMenu } from "./components/consultant-pipeline-menu";
import { ConsultantPipelineBoardContextProvider } from "./consultant-pipeline-board/use-consultant-pipeline-board-context";
import { ConsultantOpportunityBoardContextProvider } from "./consultant-opportunity-board/use-consultant-opportunity-board-context";

function ConsultantPipelinePageInner(props: RouteComponentProps<any>) {
  let tab = props.location.pathname.replace("/pipeline/", "");

  if (tab === "/pipeline") {
    tab = "consultants";
  }

  return (
    <ThemeProvider theme={bonlivaPipelineTheme}>
      <WithAlertDialog>
        <Box height="100vh" display="flex" flexDirection="column">
          <Box flex="0 0 0">
            <ConsultantPipelineMenu
              currentTab={tab}
              onTabChange={(tab) => props.history.push(`/pipeline/${tab}`)}
            />
          </Box>

          {/*<Box flex="1 0 auto" pl={2} pr={2} mt={2}>*/}

          <Switch>
            <Route path="/pipeline/consultants">
              <ErrorBoundary>
                <ConsultantPipelineBoardContextProvider>
                  <ConsultantPipelineBoard />
                </ConsultantPipelineBoardContextProvider>
              </ErrorBoundary>
            </Route>

            <Route path="/pipeline/presentations">
              <ErrorBoundary>
                <ConsultantOpportunityBoardContextProvider>
                  <ConsultantOpportunityBoard />
                </ConsultantOpportunityBoardContextProvider>
              </ErrorBoundary>
            </Route>

            <Route path="/pipeline/stats">
              <ErrorBoundary>
                <ConsultantOpportunityStats />
              </ErrorBoundary>
            </Route>

            <Route>
              <ErrorBoundary>
                <ConsultantPipelineBoardContextProvider>
                  <ConsultantPipelineBoard />
                </ConsultantPipelineBoardContextProvider>
              </ErrorBoundary>
            </Route>
          </Switch>
        </Box>
      </WithAlertDialog>
    </ThemeProvider>
  );
}

export const ConsultantPipelinePage = withRouter(ConsultantPipelinePageInner);
